import { useState } from "react";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";
import { subscribe } from "@/lib/api";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await subscribe(email);
      toast.success("You're in! Welcome to the PawJournal family.");
      setEmail("");
    } catch (err) {
      toast.error(
        err?.response?.data?.detail || "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      data-testid="newsletter-section"
      className="bg-[#839788] text-[#FAF9F6] rounded-[3rem] my-20 mx-4 md:mx-8 px-8 py-20 md:py-24 flex flex-col items-center text-center"
    >
      <span className="grid place-items-center h-14 w-14 rounded-full bg-white/15 mb-6">
        <Mail size={24} strokeWidth={1.5} />
      </span>
      <h2 className="font-serif text-4xl sm:text-5xl tracking-tight mb-4 max-w-2xl">
        Little letters for big-hearted pet parents
      </h2>
      <p className="font-sans text-white/85 max-w-xl mb-8 leading-relaxed">
        Gentle tips, warm stories, and seasonal care guides — delivered to your
        inbox once a week. No noise, just love for animals.
      </p>
      <form
        onSubmit={handleSubmit}
        className="flex flex-col sm:flex-row gap-3 w-full max-w-lg"
      >
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          data-testid="newsletter-email-input"
          className="rounded-full bg-white/10 border border-white/25 text-white placeholder-white/60 px-6 py-3.5 flex-1 outline-none focus:ring-2 focus:ring-[#D96B43] transition"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit-button"
          className="rounded-full bg-[#D96B43] text-white px-8 py-3.5 font-sans font-medium hover:-translate-y-0.5 hover:bg-[#C25D3A] transition-all duration-300 disabled:opacity-70 flex items-center justify-center gap-2"
        >
          {loading ? <Loader2 size={18} className="animate-spin" /> : "Subscribe"}
        </button>
      </form>
    </section>
  );
}
